import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-therapie-login',
  templateUrl: './therapie-login.component.html',
  styleUrls: ['./therapie-login.component.scss']
})
export class TherapieLoginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
